function EditUserPage() {

    return (
        <>
            <h1>Edit User</h1>
        </>
    );
}

export default EditUserPage;
